const $inject = ['$window'];

const helpPanelService = function ($window) {
  let service = {
    // searchForm, flightResults, hotelResults, carResults
    handleShow
  };

  function handleShow(helpPanelContentKey) {
    window.svelteStore.helpPanelShow.set(true);
    window.svelteStore.helpPanelContentKey.set(helpPanelContentKey);
  }

  return service;
};

helpPanelService.$inject = $inject;

export default helpPanelService;



// WEBPACK FOOTER //
// ./src/services/helpPanelService.js